
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.link-grid-block{
  --heading-color:var(--brand-white);

  background-color:var(--brand-primary-dark-blue);
  color:var(--brand-white);
  padding:var(--spacing-13) var(--spacing-2);
  display:flex;
  flex-direction:column;
  gap:var(--spacing-5);
}

  @media (min-width: 768px){.link-grid-block{
    flex-direction:row;
    align-items:center;
    gap:0;
    padding:var(--spacing-10) var(--spacing-2)
}
  }

  @media (min-width: 1024px){.link-grid-block{
    padding:var(--spacing-10) var(--spacing-12)
}
  }

table{
  border-collapse:collapse;
  table-layout:fixed;
  width:100%;
}

tr{
  display:flex;
  flex-direction:column;
}

tr:last-child{
    border-bottom:0;
  }

@media (min-width: 768px){

tr{
    display:table-row;
    border-bottom:3px solid var(--brand-blue-600)
}
  }

tr:first-child tds:first-child{
  border-top:3px solid var(--brand-blue-600);
}

@media (min-width: 768px){

tr:first-child tds:first-child{
    border-top:0
}
  }

td{
  width:100%;
  border-bottom:3px solid var(--brand-blue-600);
}

td:nth-child(3){
    border-right:0;
  }

@media (min-width: 768px){

td{
    width:33.33%;
    border-bottom:0;
    border-right:3px solid var(--brand-blue-600)
}
  }

a{
  font-size:var(--text-base);
  font-family:var(--ff-display);
  letter-spacing:0.125rem;
  line-height:1.2;
  text-align:center;
  display:flex;
  flex-direction:row;
  align-items:center;
  justify-content:space-between;
  gap:var(--spacing-4);
  width:100%;
  padding:var(--spacing-5) 0;
  text-align:left;
}

@media (min-width: 768px){

a{
    padding:var(--spacing-9) var(--spacing-5) var(--spacing-5);
    flex-direction:column;
    text-align:center
}
  }

@media (min-width: 1024px){

a{
    font-size:var(--spacing-5)
}
  }

a:hover outline-icon-baseline{
  transform:scale(1.25);
}

a:hover outline-icon-baseline .right-icon-container{
    transform:translateX(var(--spacing-2));
  }

outline-icon-baseline{
  border-radius:4px;
  background-color:var(--brand-primary-blue);
  display:flex;
  align-items:center;
  justify-content:center;
  transition:transform 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  width:2rem;
  height:2rem;
  color:var(--brand-primary-dark-blue);
}
`;